<template>
  <div class="header-main">
    <div class="header-bg">
      <div class="nav"></div>
      <div class="nav-content">
        <div class="nav-logo"></div>
        <OEMMenu />
        <div class="nav-right">
          <OEMLanguage />
          <OEMPortrait />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OEMMenu from "../OEMMenu/index";
import OEMLanguage from "../OEMLanguage/index.vue";
import OEMPortrait from "../OEMPortrait/index.vue";

export default {
  name: "OEMHeader",
  components: {
    OEMMenu,
    OEMLanguage,
    OEMPortrait,
  },
};
</script>

<style lang="less" scoped>
.header-main {
  width: 100%;
  height: 60px;
  
}

.header-bg {
  width: 100%;
  height: 52px;
  background-color: #000;
  position: relative;
}

.nav {
  width: 100%;
  height: 60px;
  background-image: url("../../assets/images/nav.png");
  background-size: 100% 100%;
}

.nav-content {
  width: 100%;
  height: 52px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
}

.nav-logo {
  width: 186px;
  height: 29px;
  background-image: url("../../assets/images/nav_logo.png");
  background-size: 100% 100%;
  margin-left: 16px;
  margin-top: 14px;
}

.nav-right {
  display: flex;
}
</style>
